import React, { memo } from 'react';
export function SocialProofSection() {
  const values = ['Explicaciones claras y fáciles de entender.', 'Enfoque práctico: leés desde el primer día.', 'Material de consulta confiable siempre a mano.', 'Seguridad real al leerle a otras personas.'];
  const testimonials = [{
    quote: 'Con el Tomo 2 por fin entendí la lógica de los elementos y dejé de memorizar. Un antes y un después.',
    name: 'Mariana G.',
    role: 'Tarotista principiante',
    location: 'Buenos Aires'
  }, {
    quote: 'La guía de tiradas me cambió todo. Ahora tengo opciones para cualquier pregunta que me hagan.',
    name: 'Carolina M.',
    role: 'Estudiante de Tarot',
    location: 'Buenos Aires'
  }, {
    quote: 'El módulo profesional me dio la seguridad para cobrar por mis lecturas. Ya recuperé la inversión.',
    name: 'Agustina L.',
    role: 'Tarotista Profesional',
    location: 'Buenos Aires'
  }, {
    quote: 'Directo al grano, sin relleno y con un diseño hermoso. Las palabras clave de cada carta son mi salvación.',
    name: 'Gabriela D.',
    role: 'Astróloga y Tarotista',
    location: 'Buenos Aires'
  }];
  return <section className="px-4 py-12" data-id="element-230">
      <div className="max-w-4xl mx-auto" data-id="element-231">
        <h2 className="mb-4 text-3xl font-bold text-center md:text-4xl text-brand-teal" data-id="element-232">
          Lo que valoran nuestras estudiantes
        </h2>
        <div className="grid gap-3 mb-10 md:grid-cols-2" data-id="element-233">
          {values.map((val, i) => <div key={i} className="flex items-start gap-3 p-4 rounded-lg bg-brand-cream/50" data-id="element-234">
              <span className="text-brand-amber font-bold mt-0.5" data-id="element-235">✓</span>
              <p className="text-brand-dark/80" data-id="element-236">{val}</p>
            </div>)}
        </div>

        <h3 className="mb-6 text-2xl font-bold text-center text-brand-teal" data-id="element-237">
          Experiencias reales 💬
        </h3>

        <div className="grid gap-6 md:grid-cols-2" data-id="element-238">
          {testimonials.map((t, i) => <div key={i} className="p-6 bg-[#1a1a1a] border border-brand-teal/20 rounded-xl" data-id="element-239">
              <p className="mb-4 text-brand-dark/80 italic leading-relaxed" data-id="element-240">
                "{t.quote}"
              </p>
              <div data-id="element-241">
                <p className="font-bold text-brand-teal" data-id="element-242">{t.name}</p>
                <p className="text-sm text-brand-dark/60" data-id="element-243">
                  {t.role} — {t.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}